// extracted by mini-css-extract-plugin
module.exports = {"wrap":"tf","heading":"uf","items":"vf","featureCss":"wf","disabled":"xf","imgCss":"yf"};